import React from 'react';
import styled from 'styled-components';
import { rem } from 'polished';
import validator from 'validator';
import b2bRoles from '../../../../ContentConfig/b2bRoles';
import { Loader, Button, Input, Select } from 'oxyrion-ui/lib';
import { connect } from '../../../../Store';
import CheckAccess from '../../../../ACL/CheckAccess';
import AlertPopup from '../../../../Components/AlertPopup';
import { __, getIdFromProps } from '../../../../Utils';
import { LoaderWrapper } from '../../../../Components/ReusableComponents';
import ErrorMessage from '../../../../Components/ErrorMessage';
import CatalogCheckbox from '../../../ProductCatalog/Components/CatalogCheckbox';
import PopUpWrapper from '../../../../Components/PopUpWrapper';
import RolesMapTable from '../../../../Components/RolesMapTable';
import API2 from '../../../../API2';

const Wrapper = styled.div`
  padding: ${rem(16)};
`;

const MainWrapper = styled.div`
  padding: ${rem(16)};
  display: flex;
  flex-direction: column;
  background: #eee;
  margin-top: ${rem(16)};
`;

const CheckboxesWrapper = styled.div`
  display: flex;
`;

const ActivationWrapper = styled.div`
  display: flex;
  padding: ${rem(8)};
  margin-top: ${rem(16)};
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

const ShortInput = styled(Input)`
  max-width: ${rem(200)};
`;

const LongInput = styled(Input)`
  max-width: ${rem(408)};
`;

const UserNameError = styled.div`
  color: red;
  display: flex;
  margin-bottom: 4px;
`;

const Title = styled.div`
  font-size: ${rem(26)};
  font-weight: 400;
  color: #434245;
  margin-bottom: ${rem(10)};
`;

const Label = styled.div`
  display: flex;
  color: #434245;
  margin-right: 16px;
  margin-bottom: ${rem(4)};
  font-weight: bold;
  width: ${rem(170)};
`;

const Row = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  font-size: ${rem(14)};
  margin-bottom: ${rem(8)};
`;

const InputWrapper = styled.div`
  margin-right: ${rem(56)};
  display: flex;
  flex-direction: column;
`;

class UserDetail extends React.Component {
  state = {
    loading: true,
    data: {},
    activationData: {},
    rolesMap: null,
  };

  async componentDidMount() {
    const { myAccount, id } = this.props;

    const idToFetch = !myAccount ? getIdFromProps(this.props) : id;
    if (idToFetch !== 'new') {
      await this.fetchData(idToFetch);
    } else {
      this.setState({
        loading: false,
      });
    }
  }

  async fetchData(id) {
    try {
      const data = await API2.getB2BUserAction(id);
      const rolesMap = await API2.getB2BRolesPermissionsMap();

      this.setState({
        data,
        loading: false,
        rolesMap,
      });
    } catch (e) {
      console.log(e);
    }
  }

  handleRoleChange(role) {
    const { data } = this.state;

    data.b2b_credentials.role = role;

    this.setState({
      data,
      success: false,
      error: false,
    });
  }

  handleChange(field, value) {
    const { data } = this.state;

    data[field] = value;

    this.setState({
      data,
      success: false,
      error: false,
      emailNotValid: false,
    });
  }

  handleActivationDataChange(field, value) {
    const { activationData } = this.state;
    activationData[field] = value;

    this.setState({
      activationData,
      userNameError: false,
    });
  }

  checkData(data) {
    if (
      data.name.length < 1 ||
      data.surname.length < 1 ||
      data.phone.length < 1 ||
      data.email.length < 1
    ) {
      return false;
    }

    if (!validator.isEmail(data.email)) {
      this.setState({
        emailNotValid: true,
      });
      return false;
    }
    return true;
  }

  async saveMyAccountData() {
    const { data } = this.state;

    this.setState({
      saveLoading: true,
    });

    if (!this.checkData(data)) {
      this.setState({
        error: __('Hodnoty nie sú vyplnené správne'),
        saveLoading: false,
      });
      return false;
    }

    try {
      const result = await API2.putB2BMyAccountAction(this.props.id, {
        body: {
          name: data.name,
          surname: data.surname,
          position: data.position,
          email: data.email,
          phone: data.phone,
        },
      });

      this.setState({
        success: __('Zmeny uložené'),
        saveLoading: false,
        data: result,
      });

      return true;
    } catch (e) {
      console.log(e);

      this.setState({
        error: __('Používateľa sa nepodarilo uložiť'),
        saveLoading: false,
      });

      return false;
    }
  }

  async saveData(post = true) {
    const { data } = this.state;

    this.setState({
      saveLoading: true,
    });

    if (!this.checkData(data)) {
      this.setState({
        error: __('Hodnoty nie sú vyplnené správne'),
        saveLoading: false,
      });
      return false;
    }

    try {
      let result = data;
      if (post) {
        result = await API2.postB2BUserAction({
          body: {
            name: data.name,
            surname: data.surname,
            position: data.position,
            email: data.email,
            phone: data.phone,
          },
        });
      } else {
        result = await API2.putB2BUserAction(data._id, {
          body: {
            name: data.name,
            surname: data.surname,
            position: data.position,
            email: data.email,
            phone: data.phone,
            role: data.b2b_credentials && data.b2b_credentials.role,
          },
        });
      }

      result.b2b_credentials = data.b2b_credentials;

      this.setState({
        success: __('Zmeny uložené'),
        saveLoading: false,
        data: result,
      });

      return true;
    } catch (e) {
      console.log(e);

      this.setState({
        error: __('Používateľa sa nepodarilo uložiť'),
        saveLoading: false,
      });

      return false;
    }
  }

  async changeState(toState) {
    const { activationData, data } = this.state;

    this.setState({
      activationLoading: true,
    });

    try {
      const result = await API2.putB2BUserCredentialsAction(data._id, toState, {
        body: {
          username: toState === 'active' ? activationData.login : data.email,
          role: toState === 'active' ? activationData.role : 'b2b_user',
        },
      });

      data.b2b_credentials = toState === 'active' ? result : null;

      this.setState({
        // success: `${__('Používateľ')} bol ${
        //   toState === 'active' ? __('aktivovaný') : __('deaktivovaný')
        // }`,
        data,
        showActiveSuccess: toState === 'active',
        saveLoading: false,
        showActivationDialog: false,
        showDeactivationDialog: false,
        activationLoading: false,
      });
    } catch (e) {
      if (e.response.status === 409) {
        this.setState({
          saveLoading: false,
          activationLoading: false,

          userNameError: true,
        });
      } else {
        this.setState({
          error: `${__('Používateľa')} sa nepodarilo ${
            toState === 'active' ? __('aktivovať') : __('deaktivovať')
          }`,
          saveLoading: false,
          showActivationDialog: false,
          showDeactivationDialog: false,
          activationLoading: false,
        });
      }
    }
  }

  render() {
    const { myAccount, roles } = this.props;

    const {
      loading,
      activationLoading,
      saveLoading,
      data,
      activationData,
      success,
      error,
      showActivationDialog,
      showDeactivationDialog,
      userNameError,
      emailNotValid,
      showActiveSuccess,
      rolesMap,
    } = this.state;

    if (loading) {
      return (
        <LoaderWrapper>
          <Loader size="xl" color="#70af00" />
        </LoaderWrapper>
      );
    }

    return (
      <Wrapper>
        <ErrorMessage display={error} text={error} />
        <ErrorMessage display={success} success text={success} />

        <AlertPopup
          alignUnderHeader
          display={showDeactivationDialog}
          text={__('Naozaj si želáte deaktivovať používateľa?')}
          question
          onClose={() =>
            this.setState({
              showDeactivationDialog: false,
            })
          }
          onSubmit={() => this.changeState('inactive')}
        />

        <AlertPopup
          alignUnderHeader
          display={showActiveSuccess && data.b2b_credentials}
          text={`${__('Používateľ bol aktivovaný s prihlásovacím menom')}: ${
            data.b2b_credentials ? data.b2b_credentials.username : ''
          }`}
          subText={`${__('Na email')} ${data.email} ${__(
            'bol zaslaný odkaz, pre vytvorenie hesla',
          )}`}
          success
          onClose={() =>
            this.setState({
              showActiveSuccess: false,
            })
          }
          onSubmit={() =>
            this.setState({
              showActiveSuccess: false,
            })
          }
        />

        <PopUpWrapper
          display={showActivationDialog}
          message={__('Aktivácia používateľa')}
          customWidth={448}
          onClose={() =>
            this.setState({
              showActivationDialog: false,
            })
          }
          onEscClose={() =>
            this.setState({
              showActivationDialog: false,
            })
          }
        >
          <ActivationWrapper>
            <Row>
              <InputWrapper style={{ width: rem(432) }}>
                <Label>{__('Prihlásovacie meno')}</Label>
                {userNameError && (
                  <UserNameError>
                    {__('Používateľ s týmto menom už existuje')}
                  </UserNameError>
                )}
                <ShortInput
                  value={activationData.login}
                  error={userNameError}
                  placeholder={__('Login')}
                  onChange={e =>
                    this.handleActivationDataChange('login', e.target.value)
                  }
                />
              </InputWrapper>
            </Row>

            <Row>
              <InputWrapper style={{ width: rem(432) }}>
                <Label>{__('Rola')}</Label>
                <Select
                  size="xs"
                  icon="arrow-down"
                  iconRight
                  value={activationData.role}
                  style={{ height: '2.575rem', width: rem(420) }}
                  onChange={e =>
                    this.handleActivationDataChange('role', e.target.value)
                  }
                >
                  {roles.map(b => (
                    <option value={b._id}>{b.label}</option>
                  ))}
                </Select>
              </InputWrapper>
            </Row>
            <Row>
              <Button
                disabled={
                  !activationData.login || activationData.login.length < 3
                }
                onClick={() => this.changeState('active')}
                loading={activationLoading}
                primary
              >
                {__('Aktivovať')}
              </Button>
            </Row>
          </ActivationWrapper>
        </PopUpWrapper>

        {!myAccount && (
          <Button
            primary
            extrasmall
            onClick={() => this.props.history.push(`/settings/users`)}
          >
            {__('Späť')}
          </Button>
        )}
        <MainWrapper>
          <Title>
            {!myAccount
              ? `${!data._id ? __('Vytvoriť') : __('Úprava')}  ${__(
                  'používateľa',
                )}`
              : __('Upraviť môj účet')}
          </Title>
          <Row>
            <InputWrapper>
              <Label>{__('Meno')}</Label>
              <ShortInput
                value={data.name}
                placeholder={__('Meno')}
                disabled={this.props.user.role !== 'b2b_admin' && !myAccount}
                onChange={e => this.handleChange('name', e.target.value)}
              />
            </InputWrapper>

            <InputWrapper>
              <Label>{__('Priezvisko')}</Label>

              <ShortInput
                value={data.surname}
                placeholder={__('Priezvisko')}
                disabled={this.props.user.role !== 'b2b_admin' && !myAccount}
                onChange={e => this.handleChange('surname', e.target.value)}
              />
            </InputWrapper>
          </Row>

          <Row>
            <InputWrapper style={{ width: rem(432) }}>
              <Label>{__('Funkcia')}</Label>
              <LongInput
                value={data.position}
                disabled={this.props.user.role !== 'b2b_admin' && !myAccount}
                onChange={e => this.handleChange('position', e.target.value)}
                placeholder={__('Funkcia')}
              />
            </InputWrapper>
          </Row>

          <Row>
            <InputWrapper>
              <Label>{__('Email')}</Label>
              <ShortInput
                value={data.email}
                error={emailNotValid}
                disabled={this.props.user.role !== 'b2b_admin' || myAccount}
                onChange={e => this.handleChange('email', e.target.value)}
                placeholder={__('Email')}
              />
            </InputWrapper>

            <InputWrapper>
              <Label>{__('Telefón')}</Label>
              <ShortInput
                value={data.phone}
                onChange={e => this.handleChange('phone', e.target.value)}
                placeholder={__('Telefón')}
                disabled={this.props.user.role !== 'b2b_admin' && !myAccount}
              />
            </InputWrapper>
          </Row>
          {emailNotValid && (
            <Row>
              <UserNameError>{__('Nesprávny tvar emailu')}</UserNameError>
            </Row>
          )}
          {data.b2b_credentials && !myAccount && (
            <Row>
              <InputWrapper>
                <Label>{__('Rola')}</Label>
                <CheckboxesWrapper>
                  {b2bRoles.map(c => (
                    <CatalogCheckbox
                      onChange={() => this.handleRoleChange(c.value)}
                      key={c.value}
                      label={c.label}
                      value={c.value}
                      checked={data.b2b_credentials.role === c.value}
                      fontSize={14}
                      marginRight={8}
                      disabled={
                        this.props.user.role !== 'b2b_admin' && !myAccount
                      }
                    />
                  ))}
                </CheckboxesWrapper>
              </InputWrapper>
            </Row>
          )}
          <CheckAccess
            operation="putB2BUserAction"
            Component={
              <Row
                style={{
                  justifyContent: 'space-between',
                }}
              >
                {!myAccount && (
                  <Button
                    primary
                    loading={saveLoading}
                    onClick={() => this.saveData(!data._id)}
                  >
                    {!data._id ? __('Vytvoriť') : __('Upraviť')}
                  </Button>
                )}

                {data._id && !myAccount && (
                  <div>
                    {!data.b2b_credentials ? (
                      <Button
                        onClick={() => {
                          const newActivationData = {
                            login: data.email,
                            role: 'b2b_user',
                          };

                          this.setState({
                            showActivationDialog: true,
                            activationData: newActivationData,
                          });
                        }}
                        primary
                        loading={activationLoading}
                      >
                        {__('Aktivovať')}
                      </Button>
                    ) : (
                      <Button
                        onClick={() =>
                          this.setState({
                            showDeactivationDialog: true,
                          })
                        }
                        loading={activationLoading}
                        danger
                      >
                        {__('Deaktivovať')}
                      </Button>
                    )}
                  </div>
                )}
              </Row>
            }
          />

          {rolesMap && !myAccount && <RolesMapTable rolesMap={rolesMap} />}

          {myAccount && (
            <CheckAccess
              operation="putB2BMyAccountAction"
              Component={
                <Row
                  style={{
                    justifyContent: 'space-between',
                  }}
                >
                  <Button
                    primary
                    loading={saveLoading}
                    onClick={() => this.saveMyAccountData()}
                  >
                    {!data._id ? __('Vytvoriť') : __('Upraviť')}
                  </Button>
                </Row>
              }
            />
          )}
        </MainWrapper>
      </Wrapper>
    );
  }
}

const mapStateToProps = state => {
  return {
    ...state,
  };
};

export default connect(mapStateToProps)(UserDetail);



// WEBPACK FOOTER //
// ./src/Containers/Settings/Users/Detail/index.jsx